import React, { Component } from "react";
import {
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
  Button,
  CircularProgress
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Alert from '@material-ui/lab/Alert';
import { loginWithEmailAndPassword } from "../../redux/actions/LoginActions";

const styles = theme => ({
  wrapper: {
    position: "relative"
  },

  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
});

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    agreement: ""
  };
  handleChange = event => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  handleFormSubmit = event => {
    this.props.loginWithEmailAndPassword({ ...this.state });
  };
  render() {
    let { email, password } = this.state;
    let { classes } = this.props;
    return (
      <div className="signup flex justify-center w-full h-full-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: 'url("/assets/images/sign_up_bg.jpg")',
          width: "100%",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow:"hidden"
        }}
      >
        <div className="p-8">
          <Grid className="signup-card position-relative y-center" style={{
            backgroundColor: "transparent",
          }}>
            <Grid container>
              <Grid item md={1} sm={1} xs={12}></Grid>
              <Grid item md={10} sm={10} xs={12}>
                <div className="p-8 flex justify-center items-center h-full">
                  <img src="/assets/images/logoNText.png" alt="" style={{ height: "100%", width: "400%" }} />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12} align="center">
                <Grid container spacing={2}>
                  <Grid item lg={2} md={2} sm={2} xs={12}></Grid>
                  <Grid item lg={8} md={8} sm={8} xs={12}>
                    <div className="p-9 bg-white position-relative mb-10" style={{ borderRadius: "25px" }}>
                      <Alert style={{ display: this.props.login.success ? "none" : "flex" }} className="mb-4" severity="error">{this.props.login.errortitle}</Alert>
                      <ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
                        <TextValidator
                          className="mb-6 w-full"
                          variant="outlined"
                          label="Email"
                          onChange={this.handleChange}
                          type="email"
                          name="email"
                          size="small"
                          value={email}
                          validators={["required", "isEmail"]}
                          errorMessages={[
                            "this field is required",
                            "email is not valid"
                          ]}
                        />
                        <TextValidator
                          className="mb-6 w-full"
                          label="Password"
                          variant="outlined"
                          onChange={this.handleChange}
                          name="password"
                          type="password"
                          size="small"
                          value={password}
                          validators={["required"]}
                          errorMessages={["this field is required"]}
                        />
                        <Grid container>
                          <Grid item md={12} sm={12} xs={12}>
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={this.props.login.loading}
                              type="submit"
                            >
                              Sign in
                            </Button>
                          </Grid>
                          {this.props.login.loading && (
                            <CircularProgress
                              size={24}
                              className={classes.buttonProgress}
                            />
                          )}
                        </Grid>
                        <Grid container className="mt-5" spacing={2}>
                          <Grid item md={12} sm={12} xs={12}>
                            <Button
                              className="text-primary"
                              onClick={() =>
                                this.props.history.push("/session/forgot-password")
                              }
                            >
                              Forgot password?
                            </Button>
                          </Grid>
                          <Grid item md={12} sm={12} xs={12}>
                            <Button
                              disabled={this.props.login.loading}
                              className="text-primary"
                              onClick={() =>
                                this.props.history.push("/register")
                              }
                            >
                              Dont have an account? Click here to register
                            </Button>
                          </Grid>
                        </Grid>
                      </ValidatorForm>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loginWithEmailAndPassword: PropTypes.func.isRequired,
  login: state.login
});
export default withStyles(styles, { withTheme: true })(
  withRouter(connect(mapStateToProps, { loginWithEmailAndPassword })(SignIn))
);
